<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="Donation Amount">
            <FormRow inline>
              <LazyCurrencySelector :currencies="['USD', 'ILS']" />
            </FormRow>
            <div style="position: relative">
              <AmountSelector />
              <ErrorLabel field="amount" style="text-align: right" />
            </div>
          </FormSection>
          <FormSection v-if="form.amount">
            <TransactionFee />
          </FormSection>
          <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addMonthly addSplit monthesSelector/>
            </div>
          </FormSection>
          <FormSection title="Donation Designation">
            <NcsyNewjerseyDesignation />
          </FormSection>
          <FormSection>
            <InHonorOf />
          </FormSection>
          <FormSection title="Comments">
            <FormRow inline>
              <FormCol field="custom.Comments" :showLabel="false">
                <FormInput type="textarea" />
              </FormCol>
            </FormRow>
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>       
          </FormSection>
          <FormSection title="Billing Information">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton btnText="Donate Now" showAmount />
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  setup() {
    const { setValue, form, getValue } = usePaymentForm();

    return {
      form,
      getValue,
      setValue,
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep h2 {
  color: #1aa8d3;
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 25px;
}

::v-deep .form-container.ou-donation-form {
  max-width: 100%;
}
::v-deep
  .styled-radio-container--ou-donation.styled-radio-container
  input[type="radio"]:checked
  + label {
  background: #1aa8d3;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  margin-bottom: 20px;
  border-bottom: 1px solid #efefef;
}
</style>
